import isValid from "date-fns/isValid";
import parse from "date-fns/parse";
import { requestStatus } from "../../constants/statusConstants";
import { getEnv } from "../../AppConfigs";
import { Routes } from "../../AppRoutes";

export const getStepIconByStatus = (status: any) => {
  switch (status) {
    case requestStatus.approved:
      return "faCheck";
    case requestStatus.rejected:
      return "faBan";
    default:
      return "";
  }
};

export const getStepClassByStatus = (date: any, status: any) => {
  if (date) {
    return status === requestStatus.approved ? "approved" : "rejected";
  } else {
    return "waiting";
  }
};

export const getDefaultEstimatedTimeOfUse = (data: any, defaultValue: any = [new Date(), new Date()]) => {
  if (!data) {
    return defaultValue;
  }

  const [start, end] = data.split("-");

  if (!start || !end) {
    return defaultValue;
  }

  const parseStart = parse(start.trim(), "d/M/yyyy", new Date());
  const parseEnd = parse(end.trim(), "d/M/yyyy", new Date());

  if (!isValid(parseStart) || !isValid(parseEnd)) {
    return defaultValue;
  }

  return [parseStart, parseEnd];
};

export const getDefaultGender = (data: any, defaultValue: any, options: any[]) => {
  if (!data) {
    return defaultValue;
  }

  const found = options.find((i) => i.label === data);

  if (!found) {
    return defaultValue;
  }

  return found.value;
};

export const getDefaultTeam = (data: any, defaultValue: any, options: any[]) => {
  if (!data) {
    return defaultValue;
  }

  const found = options.find((i) => i.value === data);

  if (!found) {
    return null;
  }

  return found;
};

export const truncateList = (array: string[], number: number = 2) => {
  if (!Array.isArray(array)) return "";
  return array.slice(0, number).join(";") + (array.length > number ? " ..." : "");
};

export const formatMoney = (amount: number): string => {
  // Sử dụng Intl.NumberFormat để định dạng số tiền
  const formatter = new Intl.NumberFormat("vi-VN", {
    currency: "VND", // Đổi thành đơn vị tiền tệ của bạn
  });

  // Sử dụng String.prototype.replace để thêm dấu phân cách sau mỗi 3 chữ số
  return formatter.format(amount);
};

export const getListIdByFieldsContext = (context: string) => {
  const pattern = /lists\('([^']+)'\)/;
  const match = context.match(pattern);
  if (match) {
    const extractedValue = match[1];
    return extractedValue; // 'bafb5e31-0109-4c84-8077-bf1d8efbb1e8'
  } else {
    return "";
  }
};

export const getProcessPathByListId = (listId: string) => {
  switch (listId) {
    case getEnv("REACT_APP_IT_DELETEACCOUNT_REQUEST_SP_LIST_ID"):
      return Routes.deleteUserAccountDetailPage.path;
    case getEnv("REACT_APP_EPR_CODE_REQUEST_SP_LIST_ID"):
      return Routes.processEprDetailPage.path;
    case getEnv("REACT_APP_IT_CODE_REQUEST_SP_LIST_ID"):
      return Routes.processCodeGrantedDetailPage.path;
    case getEnv("REACT_APP_IT_REPAIR_INFO_SP_LIST_ID"):
      return Routes.repairITToolDetailPage.path;
    case getEnv("REACT_APP_IT_TOOLS_REQUEST_SP_LIST_ID"):
      return Routes.demandForSuppliesDetailPage.path;

    case getEnv("REACT_APP_BUSINESS_TICKET_REQUEST_LIST_ID"):
      return Routes.procedureCollaborateTicketDetailPage.path;
    case getEnv("REACT_APP_SECURITY_CONTROL_TICKET_REQUEST_LIST_ID"):
      return Routes.detailSercurityCardUnitsPage.path;
    case getEnv("REACT_APP_EXTERNAL_SERCURITY_CONTROL_TICKET_REQUEST_LIST_ID"):
      return Routes.detailExternalSercurityCardUnitsPage.path;
    case getEnv("REACT_APP_TRAVEL_CARD_REQUEST_LIST_ID"):
      return Routes.detailBusinessVeCardPage.path;
    case getEnv("REACT_APP_EXTERNAL_TRAVEL_CARD_REQUEST_LIST_ID"):
      return Routes.detailBusinessVeCardPageToExternal.path;
    case getEnv("REACT_APP_BUSNIESS_VEHICLE_REQUEST_LIST_ID"):
      return Routes.officialVehicleDetailPage.path;

    default:
      return "";
  }
};

export const getQueryKeyByListId = (listId: string) => {
  switch (listId) {
    case getEnv("REACT_APP_IT_DELETEACCOUNT_REQUEST_SP_LIST_ID"):
      return "delete-account-requests";
    case getEnv("REACT_APP_EPR_CODE_REQUEST_SP_LIST_ID"):
      return "epr-code-requests";
    case getEnv("REACT_APP_IT_CODE_REQUEST_SP_LIST_ID"):
      return "code-process-requests";
    case getEnv("REACT_APP_IT_REPAIR_INFO_SP_LIST_ID"):
      return "repair-tools-requests";
    case getEnv("REACT_APP_IT_TOOLS_REQUEST_SP_LIST_ID"):
      return "demand-for-supplies-requests";

    case getEnv("REACT_APP_BUSINESS_TICKET_REQUEST_LIST_ID"):
      return "business-tickets-requests";
    case getEnv("REACT_APP_SECURITY_CONTROL_TICKET_REQUEST_LIST_ID"):
      return "security-control-card-requests";
    case getEnv("REACT_APP_EXTERNAL_SERCURITY_CONTROL_TICKET_REQUEST_LIST_ID"):
      return "security-card-units-requests";
    case getEnv("REACT_APP_TRAVEL_CARD_REQUEST_LIST_ID"):
      return "vehicle-travel-card-requests";
    case getEnv("REACT_APP_EXTERNAL_TRAVEL_CARD_REQUEST_LIST_ID"):
      return "external-vehicle-travel-card-requests";
    case getEnv("REACT_APP_BUSNIESS_VEHICLE_REQUEST_LIST_ID"):
      return "vehicle-requests";

    default:
      return "";
  }
};




